import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-area: display;
  padding: 1rem;
`;
